import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 px-6 py-3 flex-shrink-0">
      <div className="container mx-auto flex items-center justify-between">
        <p className="text-sm text-gray-500">©  {new Date().getFullYear()} - Help at Home, LLC</p>
      </div>
    </footer>
  );
};

export default Footer;
